module.exports = __webpack_public_path__ + "img/london.1e37c5d4.jpg";